"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _AppTableFilter = _interopRequireDefault(require("../../../../components/crud/table/AppTableFilter"));

var _Api = _interopRequireDefault(require("../../../../logic/api/Api"));

var _index = require("../../../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SchoolReports = /*#__PURE__*/function (_React$Component) {
  _inherits(SchoolReports, _React$Component);

  function SchoolReports() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SchoolReports);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SchoolReports)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      downloading: false,
      loading: false,
      activatedCards: "0",
      atmTransactions: "0",
      atmTransactionsAverageValue: "0",
      atmTransactionsValue: "0",
      donationsAverageValue: "0",
      donationsCount: "0",
      donationsTotalValue: "0",
      giftAidNumberOfSignedUp: "0",
      giftAidPercentageOfSignedUp: "0",
      giftAidTotalValue: "0",
      loadedCards: "0",
      loadsAverageValue: "0",
      loadsCount: "0",
      loadsValue: "0",
      orderedCards: "0",
      posTransactions: "0",
      posTransactionsAverageValue: "0",
      posTransactionsValue: "0",
      schoolsRegisteredCount: "0",
      uniqueTransactingCards: "0"
    });

    return _this;
  }

  _createClass(SchoolReports, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._loadWidget();
    }
  }, {
    key: "_filter",
    value: function _filter(filter) {
      this._loadWidget(filter);
    }
  }, {
    key: "_loadWidget",
    value: function () {
      var _loadWidget2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var filter,
            result,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter = _args.length > 0 && _args[0] !== undefined ? _args[0] : []; // TODO: Load widget here

                this.setState({
                  loading: true
                });
                _context.prev = 2;
                _context.next = 5;
                return _Api["default"].call('stats/totals', {
                  filter: filter
                });

              case 5:
                result = _context.sent;
                this.setState(_objectSpread({}, result.data, {
                  loading: false
                }));
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                this.setState({
                  loading: false
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function _loadWidget() {
        return _loadWidget2.apply(this, arguments);
      }

      return _loadWidget;
    }()
  }, {
    key: "_getDownloadButton",
    value: function _getDownloadButton() {
      var _this2 = this;

      return _react["default"].createElement("a", {
        style: {
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        },
        onClick: function onClick() {
          return _this2._triggerDownload();
        },
        className: "cancelBtn",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "fa fa-fw fa-download"
      }), " ", this.state.downloading ? 'downloading...' : 'Download');
    }
  }, {
    key: "_triggerDownload",
    value: function () {
      var _triggerDownload2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.state.downloading) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.setState({
                  downloading: true
                });
                _context2.next = 5;
                return _Api["default"].downloadFile('stats/totals/download', {
                  filter: this._tableFilter.getFilter()
                });

              case 5:
                result = _context2.sent;
                setTimeout(function () {
                  _this3.setState({
                    downloading: false
                  });
                }, 500);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _triggerDownload() {
        return _triggerDownload2.apply(this, arguments);
      }

      return _triggerDownload;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react["default"].createElement("div", null, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-university",
        "aria-hidden": "true"
      }), " Reports"), _react["default"].createElement("div", {
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          padding: 5,
          display: 'flex',
          flexDirection: 'row'
        }
      }, _react["default"].createElement("div", {
        style: {
          flex: 1,
          flexGrow: 1
        }
      }, _react["default"].createElement(_AppTableFilter["default"], _extends({
        onInit: function onInit(comp) {
          return _this4._tableFilter = comp;
        },
        filter: [{
          name: 'fromDate',
          type: 'datetime',
          field: 'created',
          operation: 'gte',
          label: 'From Date'
        }, {
          name: 'toDate',
          type: 'datetime',
          field: 'created',
          operation: 'lte',
          label: 'To Date'
        }]
      }, this.props, {
        onFilter: function onFilter(filter) {
          return _this4._filter(filter);
        }
      }))), _react["default"].createElement("div", {
        style: {}
      }, this._getDownloadButton())), _react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, this.state.loading ? _react["default"].createElement(_index.LoadingOverlay, null) : null, _react["default"].createElement("div", {
        className: "row",
        style: {
          marginTop: 20
        }
      }, _react["default"].createElement("div", {
        className: "col-sm-6"
      }, _react["default"].createElement("div", {
        className: "box"
      }, _react["default"].createElement("div", {
        className: " box-header bottom-border dark"
      }, _react["default"].createElement("h2", null, "Cards")), _react["default"].createElement("div", {
        className: "box-body"
      }, _react["default"].createElement("table", {
        className: "table"
      }, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Ordered Cards"), _react["default"].createElement("td", {
        align: "right"
      }, this.state.orderedCards)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Activated Cards"), _react["default"].createElement("td", {
        align: "right"
      }, this.state.activatedCards)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Loaded Cards"), _react["default"].createElement("td", {
        align: "right"
      }, this.state.loadedCards)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Unique cards transacting"), _react["default"].createElement("td", {
        align: "right"
      }, this.state.uniqueTransactingCards))))))), _react["default"].createElement("div", {
        className: "col-sm-6"
      }, _react["default"].createElement("div", {
        className: "box"
      }, _react["default"].createElement("div", {
        className: " box-header bottom-border dark"
      }, _react["default"].createElement("h2", null, "Transactions")), _react["default"].createElement("div", {
        className: "box-body"
      }, _react["default"].createElement("table", {
        className: "table"
      }, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Number of POS transactions"), _react["default"].createElement("td", {
        align: "right"
      }, this.state.posTransactions)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Value of POS transactions"), _react["default"].createElement("td", {
        align: "right"
      }, "\xA3", this.state.posTransactionsValue)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Average POS transaction value"), _react["default"].createElement("td", {
        align: "right"
      }, "\xA3", this.state.posTransactionsAverageValue)), _react["default"].createElement("tr", {
        className: "tr-dark-bg tr-no-height"
      }, _react["default"].createElement("td", {
        className: ""
      }), _react["default"].createElement("td", {
        align: "right"
      })), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Number of ATM transactions"), _react["default"].createElement("td", {
        align: "right"
      }, this.state.atmTransactions)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Value of ATM transactions"), _react["default"].createElement("td", {
        align: "right"
      }, "\xA3", this.state.atmTransactionsValue)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Avg ATM transaction value"), _react["default"].createElement("td", {
        align: "right"
      }, "\xA3", this.state.atmTransactionsAverageValue)), _react["default"].createElement("tr", {
        className: "tr-dark-bg tr-no-height"
      }, _react["default"].createElement("td", {
        className: ""
      }), _react["default"].createElement("td", {
        align: "right"
      })), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Number of loads"), _react["default"].createElement("td", {
        align: "right"
      }, this.state.loadsCount)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Value of loads"), _react["default"].createElement("td", {
        align: "right"
      }, "\xA3", this.state.loadsValue)), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "Average load value"), _react["default"].createElement("td", {
        align: "right"
      }, "\xA3", this.state.loadsAverageValue))))))))));
    }
  }]);

  return SchoolReports;
}(_react["default"].Component);

exports["default"] = SchoolReports;